/**
 * DescriptionContent component.
 */
import AIIcon from '@components/atoms/icons/AI';
import Container from '@components/atoms/container/descriptionContentContainer';
import Context from '@shared/components/utils/context/descriptionContext';
import Info from '@components/elements/description/descriptionInfo';
import Synopsis from '@components/atoms/text/descriptionSynopsis';
import Tip from '@components/elements/description/descriptionTip';
import Title from '@components/atoms/text/descriptionTitle';
import { useAppSelector } from '@shared/store/hooks';
import { useContext } from 'react';
import { DELAY, DURATION } from '@shared/types/constants/animations';
import { selectMenuCollapse } from '@shared/store/slices/menu.slice';

/**
 * Renders the description content for the focused asset in a rail.
 */
export default function DescriptionContent() {
  const { metadata, alternateTip } = useContext(Context);
  const { displayAI, displayTip, synopsis, title } = metadata ?? {};
  // Follow the rails when the menu expands (only reachable on timeline pages)
  const menuExpanded = !useAppSelector(selectMenuCollapse);
  return (
    <Container
      menuExpanded={menuExpanded}
      delay={DELAY.DESCRIPTION_CONTENT}
      duration={DURATION.DESCRIPTION_CONTENT}
      transition={`transform ${DURATION.RAILS_WRAPPER}ms ease-out`}
    >
      <Title>
        {displayAI ? <AIIcon /> : null} {title}
      </Title>
      <Info />
      <Synopsis>{synopsis}</Synopsis>
      {displayTip ? <Tip alternateTip={alternateTip} /> : null}
    </Container>
  );
}
